import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function IDFormatValidator(control: AbstractControl): ValidationErrors | null;
export function IDFormatValidator(idTypeControlName: string): ValidatorFn;
export function IDFormatValidator(arg: AbstractControl | string): ValidationErrors | null | ValidatorFn {
  // Si es string, retorna función validadora
  if (typeof arg === 'string') {
    return (control: AbstractControl): ValidationErrors | null => {
      if (control.parent) {
        const idTypeControl = control.parent.get(arg);
        if (!idTypeControl) return null;
        
        const idType = idTypeControl.value;

        if (idType === 'national id' || idType === 'foreigner card') {
          const numbersOnly = new RegExp(/^-?(0|[0-9]\d*)?$/).test(control.value);
          if (!numbersOnly) {
            return { numbersOnly: true };
          }
        }
      }
      return null;
    };
  }
  
  // Si es AbstractControl, valida directamente
  if (arg.parent) {
    const idType = arg.parent.get('idType')?.value;

    if (idType === 'national id' || idType === 'foreigner card') {
      const numbersOnly = new RegExp(/^-?(0|[0-9]\d*)?$/).test(arg.value);
      if (!numbersOnly) {
        return { numbersOnly: true };
      }
    }
  }
  return null;
}